import { ReactNode } from 'react';
import {
    Container,
    getBreakpointRangeValueFallback,
    isAtMostTablet,
    Stack,
    Typography,
    useBreakpointRange,
} from '@optimus-web/core';

export interface PageTitleProps {
    pageTitle: ReactNode;
    titleSuffixSlot?: ReactNode;
    titlePrefixSlot?: ReactNode;
}

export const PageTitle = ({ pageTitle, titleSuffixSlot, titlePrefixSlot }: PageTitleProps) => {
    const breakpointRange = useBreakpointRange();
    const isSmall = isAtMostTablet(getBreakpointRangeValueFallback(breakpointRange));

    return (
        <Container padding={['0', '0', '0', '100']}>
            <Stack spacing="100" itemAlignment="center">
                {titlePrefixSlot}
                <Typography textStyle={isSmall ? 'titleMediumStrong' : 'titleLargeStrong'} as="h1">
                    {pageTitle}
                </Typography>
                {titleSuffixSlot}
            </Stack>
        </Container>
    );
};
